export default "__VITE_ASSET__eMHhEh2T__"